<div class="banner">
    @if (isTestEnvironment && environmentBannerType === IconType.hide) {
        <nz-alert
            nzType="info"
            nzBanner
            [nzMessage]="
                'Test/QA Environment: ' + (profileProvider.email$ | async)
            "></nz-alert>
    }
</div>
<div class="app-header-content">
    <div class="app-header-left">
        @if (!layoutService.isHidden) {
            <div class="burger-menu">
                <pf-button buttonType="action" (click)="displayMenuFn()">
                    <pf-icon iconType="menu"></pf-icon>
                </pf-button>
            </div>
        }
        @if (logoLink) {
            <a class="logo logo--link" [routerLink]="logoLink">
                <img
                    [src]="brandingService.branding.logoLocation"
                    [attr.alt]="brandingService.branding.name" />
                <h3>{{ brandingService.pageTitle }}</h3>
            </a>
        } @else {
            <div class="logo">
                <img
                    [src]="brandingService.branding.logoLocation"
                    [attr.alt]="brandingService.branding.name" />
                <h3>{{ brandingService.pageTitle }}</h3>
            </div>
        }
    </div>
    <div id="app-header-actions">
        <ng-content select="[header-actions]"></ng-content>
        @if (showMenuIcon) {
            <pf-icon
                icon-right
                iconType="menu"
                (click)="layoutService.openMenu()"></pf-icon>
        }
        @if (isTestEnvironment) {
            <pf-button
                id="app-header-env-btn"
                (click)="switchEnvironmentBanner()"
                buttonType="action"
                tooltip="Hide/View Environment Banner">
                <pf-icon [iconType]="environmentBannerType"></pf-icon>
            </pf-button>
        }
    </div>
</div>
<ng-content select="[header-bottom]"></ng-content>
<nz-drawer
    [nzClosable]="false"
    [nzVisible]="layoutService.menuVisible"
    nzPlacement="bottom"
    nzTitle="Menu"
    [nzHeight]="'85vh'"
    (nzOnClose)="layoutService.closeMenu()">
    <ng-container *nzDrawerContent>
        <div id="app-header-menu">
            @if (profileProvider.email$ | async) {
                <div id="app-header-menu-user">
                    <pf-text type="description"> Logged in as</pf-text>
                    <pf-text
                        id="app-header-menu-user-name"
                        type="subtitle"
                        class="primary"
                        >{{ profileProvider.profile.fullName }} -
                        {{ profileProvider.profile.email }}
                    </pf-text>
                </div>
            }
            <ng-content select="[app-header-menu]"></ng-content>
            @if (allowPasswordReset) {
                <pf-button buttonType="refresh" block (click)="resetPassword()"
                    >Reset Password
                </pf-button>
            }
            <pf-button buttonType="rounded" block secondary (click)="logout()"
                >Logout
            </pf-button>
        </div>
    </ng-container>
</nz-drawer>
